import { Jwt } from './jwt.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class Cookie {
    static jsonMap = {
        jwt: { key: 'jwt', converter: new (ClassConverterFactory.build(Jwt))() },
        idOrganisme: 'idOrganisme',
        idDomaine: 'idDomaine'
    };

    jwt: Jwt = undefined;
    idOrganisme: number = undefined;
    idDomaine: number = undefined;
}
